document.body.addEventListener('click', (e) => {
    // 1. Handle toggler click
    const toggler = e.target.closest('.include-selling-plan');
    if (toggler) {
      e.preventDefault();
  
      const cartRow = toggler.closest('tr[id^="CartDrawer-Item-"], tr[id^="CartItem-"]');
      if (!cartRow) return;
  
      const groups = cartRow.querySelector('.selling-plan-groups');
      const isActive = toggler.classList.contains('active');
  
      const firstOption = cartRow.querySelector('.selling-plan-option');
      const lineNumber = firstOption?.dataset.lineNumber;
      const quantity = firstOption?.dataset.lineQuantity;
  
      // Close all other open togglers
      document.querySelectorAll('.include-selling-plan.active').forEach(el => {
        if (!cartRow.contains(el)) el.classList.remove('active');
      });
      document.querySelectorAll('.selling-plan-groups.visible').forEach(group => {
        if (!cartRow.contains(group)) {
          group.classList.remove('visible');
          group.classList.add('hidden');
        }
      });
  
      if (isActive) {
        toggler.classList.remove('active');
        groups?.classList.remove('visible');
        groups?.classList.add('hidden');
        if (lineNumber && quantity) updateCart(lineNumber, quantity, null);
      } else {
        toggler.classList.add('active');
        groups?.classList.remove('hidden');
        groups?.classList.add('visible');
      }
  
      return;
    }
  
    // 2. Handle selling plan option click
    const option = e.target.closest('.selling-plan-option');
    if (option) {
      const cartRow = option.closest('tr[id^="CartDrawer-Item-"], tr[id^="CartItem-"]');
      if (!cartRow) return;
  
      cartRow.querySelectorAll('.selling-plan-option').forEach(opt => opt.classList.remove('active'));
      option.classList.add('active');
  
      const lineNumber = option.dataset.lineNumber;
      const quantity = option.dataset.lineQuantity;
      const sellingPlanId = Number(option.dataset.sellingPlanOption);
  
      updateCart(lineNumber, quantity, sellingPlanId);
    }
  });
  
  function updateCart(lineNumber, quantity, sellingPlanId) {
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (cartItems && lineNumber && quantity) {
      cartItems.changeLineItemSellingPlan(Number(lineNumber), Number(quantity), sellingPlanId);
    }
  }